"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherChannelsType = void 0;
var PusherChannelsType;
(function (PusherChannelsType) {
    PusherChannelsType["Events"] = "Events";
    PusherChannelsType["Notifications"] = "Notifications";
})(PusherChannelsType = exports.PusherChannelsType || (exports.PusherChannelsType = {}));
